export class LoginPeticion {
    docEmpresa: string = "-1";
    docUsuario: string = "-1";
    claveUsuario: string = "-1";
    codCliente: string = "-1";
    codTpoPortal: string = "-1";
}